<template>
  <suspicious-activity-reviews
    :is-loading="isLoading"
    :suspicious-activity-reviews="suspiciousActivityReviews"
    :project-options="projectOptions"
    @load-reviews="loadReviews"
    @update-status="onUpdateStatus"
    @toggle-permission="onTogglePermission"
    @update-comment="onUpdateComment"
  />
</template>

<script>
import { API } from '@/utils/api'
import SuspiciousActivityReviews from '../components/SuspiciousActivityReviews.vue'
const LIST_REVIEWS = '/$v/suspicious_activity_review/list.json'
const UPDATE_REVIEW_STATUS = '/$v/suspicious_activity_review/update.json'
const UPDATE_ACCOUNT = '/$v/account/update.json'

export default {
  components: {
    SuspiciousActivityReviews,
  },
  data() {
    return {
      isLoading: false,
      suspiciousActivityReviews: [],
      lastQueriedEntityIds: [],
    }
  },
  computed: {
    projectOptions() {
      return this.$store.state.auth.entities.map((entity) => ({ text: entity.name, value: entity.entity_id }))
    }
  },
  methods: {
    loadReviews({ entityIds, statuses }) {

      this.isLoading = true

      return API.call(LIST_REVIEWS, {
        by_entities: entityIds,
        statuses:    statuses,
      }).then(r => this.suspiciousActivityReviews = r.data)
      .finally(() => this.isLoading = false, this.lastQueriedEntityIds = entityIds)
    },
    onUpdateStatus({review_id, status}) {
      this.isLoading = true

      return API.call(UPDATE_REVIEW_STATUS, {
        status,
        suspicious_activity_review_id: review_id,
      }).then(() => this.loadReviews(this.lastQueriedEntityIds))
    },
    onTogglePermission(permissionKey, review) {
      this.isLoading = true

      return API.call(UPDATE_ACCOUNT, {
        entity_id: review.entity_id,
        login: review.account.login,
        fields: {
          [`data.access_limit.${permissionKey}`]: !review.account.access_limit?.[permissionKey],
        }
      }).then(() => {
        this.updateAccountStatus(review.account.login, permissionKey, review.account.access_limit?.[permissionKey])
      })
      .finally(() => this.isLoading = false)
    },
    updateAccountStatus(login, permissionKey, value) {
      for (const review of this.suspiciousActivityReviews) {
        if (review.account.login === login) {
          if (!review.account.access_limit) {
            this.$set(review.account, 'access_limit', {
              [permissionKey]: value
            })
          } else {
            this.$set(review.account.access_limit, permissionKey, value)
          }
        }
      }
    },
    onUpdateComment(review) {
      this.isLoading = true

      return API.call(UPDATE_REVIEW_STATUS, {
        operator_comment: review.operator_comment,
        suspicious_activity_review_id: review.suspicious_activity_review_id,
      })
        .finally(() => this.isLoading = false)
    }
  }
}
</script>
